// extracted by mini-css-extract-plugin
export var equalColumn = "_j9-0";